// L1 — top-level stage A..J. Delegates L2 children to StageRailItemL2.
import { useState } from "react";
import { Lock } from "lucide-react";
import { RAIL_STATUS_META, effectiveStatus } from "./stageRailUtils";
import RailDependencyTooltip, { RailItemButton } from "./stageRailShared";
import StageRailItemL2 from "./StageRailItemL2";

export default function StageRailItem({ stage, flatByCode, catalogue, activeCode, onPick, gateStatus, phaseVisibility, projectId, downloadableModules }) {
  const [open, setOpen] = useState(true);
  const [depsOpen, setDepsOpen] = useState(false);
  const state = flatByCode[stage.code] || { status: "not_started" };
  const effStatus = effectiveStatus(stage, state, flatByCode);
  const isLocked = effStatus === "locked";
  const meta = RAIL_STATUS_META[isLocked ? "not_started" : effStatus] || RAIL_STATUS_META.not_started;
  const Icon = isLocked ? Lock : meta.Icon;
  const subs = stage.sub_stages || [];
  const isActive = activeCode === stage.code;
  const hasSubs = subs.length > 0;
  const phaseCell = phaseVisibility?.stages?.[stage.code];
  const gate = gateStatus?.[stage.code] || null;
  // Phase 5 Final WS4 — compute "X / Y complete" progress for L1.
  // A module is considered complete when its gate-status reports
  // `has_output=true` and `has_errors=false`.
  const countDone = subs.reduce((acc, ss) => {
    const g = gateStatus?.[ss.code];
    return acc + (g?.has_output && !g?.has_errors ? 1 : 0);
  }, 0);
  const progressLabel = subs.length > 0
    ? `${countDone}/${subs.length}`
    : null;
  return (
    <div data-testid={`rail-stage-${stage.code}`}>
      <RailItemButton
        stage={stage} level={1} isLocked={isLocked} isActive={isActive}
        meta={meta} Icon={Icon} hasSubs={hasSubs} open={open}
        pad={14} fontSize={13}
        phaseCell={phaseCell}
        gate={gate}
        progressLabel={progressLabel}
        onClick={() => {
          onPick(stage.code);
          if (hasSubs) setOpen(!open);
          if (isLocked) setDepsOpen(!depsOpen);
        }}
      />
      {isLocked && depsOpen && (
        <RailDependencyTooltip stageSpec={stage} flatByCode={flatByCode} catalogue={catalogue} />
      )}
      {hasSubs && open && (
        <div>
          {subs.map((ss) => (
            <StageRailItemL2 key={ss.code} stage={ss}
                flatByCode={flatByCode} catalogue={catalogue}
                activeCode={activeCode} onPick={onPick}
                gateStatus={gateStatus}
                phaseVisibility={phaseVisibility}
                projectId={projectId}
                downloadableModules={downloadableModules} />
          ))}
        </div>
      )}
    </div>
  );
}
